(function () {
  'use strict';

  function factRows(text, Segmenter) {
    if (typeof text !== 'string' || !text || typeof Segmenter !== 'function') return [];
    try {
      const rows = Array.from(new Segmenter('en', { granularity: 'sentence' }).segment(text), row => row.segment);
      return rows.length >= 3 && rows.length <= 64 && rows.join('') === text ? rows : [];
    } catch (_) { return []; }
  }

  function enhance(scope, enabled, Segmenter) {
    if (!enabled || !scope) return 0;
    let changed = 0;
    for (const heading of scope.querySelectorAll('h3')) {
      if (heading.textContent.trim() !== 'Choosing the right option') continue;
      const paragraph = heading.nextElementSibling;
      if (!paragraph || paragraph.tagName !== 'P' || paragraph.children.length) continue;
      const original = paragraph.textContent;
      const rows = factRows(original, Segmenter);
      if (!rows.length) continue;
      const list = paragraph.ownerDocument.createElement('ul');
      list.className = 'pawroutine-fetch-fit-facts';
      for (const name of ['id', 'lang', 'dir']) {
        if (paragraph.hasAttribute(name)) list.setAttribute(name, paragraph.getAttribute(name));
      }
      for (const text of rows) {
        const item = paragraph.ownerDocument.createElement('li');
        item.textContent = text;
        list.appendChild(item);
      }
      // Presentation only: the validated text and its punctuation stay exact.
      if (list.textContent !== original) continue;
      paragraph.replaceWith(list);
      changed++;
    }
    return changed;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { factRows, enhance };
  if (typeof document === 'undefined') return;
  function boot() {
    const enabled = !!document.querySelector('script[data-pawroutine-fetch-fit="1"]');
    enhance(document.querySelector('main'), enabled, typeof Intl === 'undefined' ? null : Intl.Segmenter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
